export default __webpack_public_path__ + "static/media/flag-eu.8510faaf.svg";